import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a18ad66"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "Publishing of health priority need")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Display = _resolveComponent("Display")!
  const _component_FormModal = _resolveComponent("FormModal")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.layout)
      ? (_openBlock(), _createBlock(_component_Header, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["container-lg container-fluid", { evaluate: _ctx.layout }])
    }, [
      _hoisted_1,
      _createVNode(_component_Display, {
        id: _ctx.id,
        modal: _ctx.modal,
        onEvaluated: _ctx.onEvaluate
      }, null, 8, ["id", "modal", "onEvaluated"]),
      (_ctx.authStatus === false)
        ? (_openBlock(), _createBlock(_component_FormModal, { key: 0 }))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.layout)
      ? (_openBlock(), _createBlock(_component_Footer, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}